import React, { Component }  from 'react';
import {Button, Form, Input, message,Breadcrumb,Steps,Result} from "antd";
import { SmileOutlined } from '@ant-design/icons';
import {fetchPost} from "../static/util/fetch";
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
};
const { Step } = Steps;

class forgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state={
            phone: '',
            confirmPhone:'',
            password: '',
            confirmPassword:'',
            checkCode: 111111,
            getCodeStatus:true,
            current: 0,//步骤条状态
            stepTwoDisabled:true,
            stepThreeDisabled:true,
            count:60,
            systemName:'',
        }
        this.countDown = this.countDown.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                        }))
                        if(res.data.systemColor === 1){
                            require([`./style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`./styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`./styleGray.css`], function(list){});
                        }
                    }
                }
            )
    }
    handleInputTelNumber(e){
        const value  = e.target.value;
        this.setState(()=>({
            phone:value,
        }));
    }
    returnStep1(){
        this.setState(()=>({
            current:0
        }));
    }
    switchStep(){
        if(this.state.phone === ''){
            message.error("请输入账号（手机号）！")
        }else{
            const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
            const newResPhone = regPhone.test(this.state.phone)
            if(this.state.phone.length === 11 && newResPhone === false){
                message.info('请检查手机号是否真实！').then()
            }else{
                fetchPost(global.constants.checkPhone,{phone:this.state.phone})
                    .then(
                        res=>{
                            if(res.code === -1){
                                this.setState(()=>({
                                    current:1,
                                    stepTwoDisabled:false,
                                    confirmPhone:this.state.phone,
                                }));
                            }else{
                                if(res.code === 200){
                                    alert("该账号不存在")
                                }
                            }
                        })

            }
        }
    }
    returnLogin(){
        let history = this.props.history;
        history.push('/')
    }
    handleInputPassword(e){
        const value  = e.target.value;
        this.setState(()=>({
            password:value
        }));
    }
    handleConfirmPassword(e){
        const value  = e.target.value;
        this.setState(()=>({
            confirmPassword:value
        }));
    }
    handleInputCheckCode = (e) =>{
        const value  = e.target.value;
        this.setState(()=>({
            checkCode:value
        }));
    }
    //发送验证码
    getCode(){
        let params={
            phone:this.state.confirmPhone,
        }
        if(params.phone===''){
            message.info("请输入手机号").then()
        }else{
            fetchPost(global.constants.findPhone,params)
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(()=>({
                                getCodeStatus:false,
                            }))
                            this.countDown()
                            message.success("验证码发送成功，5分钟内有效，请注意查收！").then()
                        }
                        if (res.code === -1){
                            message.info("该手机号不存在！").then()
                        }
                        if (res.code === -2) {
                            message.info("一小时内已发送五条验证短信，请稍后再试！").then()
                        }
                    }
                )
        }

    }
    countDown() {
        const { count } = this.state
        if (count === 1) {//当为0的时候，liked设置为true，button按钮显示内容为 获取验证码
            this.setState({
                count: 60,
                getCodeStatus: true,
            })
        } else {
            this.setState({
                count: count - 1,
                getCodeStatus: false,
            })
            setTimeout(() => this.countDown(), 1000)//每一秒调用一次
        }
    }
    submit(){
        const regPassword =/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/;
        const newResPassword = regPassword.test(this.state.password)
        if(this.state.password === '' ||this.state.confirmPassword === ''||this.state.checkCode === '' ){
            message.error("请完善信息！").then()
        }else{
            if(this.state.password !== this.state.confirmPassword){
                message.error("两次输入的密码不一致！").then()
            }else{
                if(newResPassword === false){
                    message.error("请注意密码格式！").then()
                    console.log(newResPassword)
                }else{
                    let params={
                        phone:this.state.confirmPhone,
                        password: this.state.password,
                        checkCode:this.state.checkCode,
                    }
                        fetchPost(global.constants.findPassword,params)
                            .then(
                                res =>{
                                    if(res.code===200){
                                        this.setState(()=>({
                                            current:2,
                                            stepThreeDisabled:false,
                                        }))
                                    }
                                    if(res.code===-1){
                                        message.info("请输入验证码！").then()
                                    }
                                    if(res.code===-2){
                                        message.info("验证码错误！").then()
                                    }
                                }
                            )
                    }
            }
        }
        }
    onChange= current =>{
        this.setState({ current })
    }

    render() {
        return(
            <div className='login'>
                <div className="login-top">
                    <div className='login-header'>
                        <span className="login-header-word" >高企认定管理系统</span>
                    </div>
                </div>
                <div className="register-background">
                    <div className="register">
                        <div className="forgetPassword">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <a href="/">登录</a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>忘记密码</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className="forgetPassword-step">
                            <Steps current={this.state.current} onChange={this.onChange}>
                                <Step title="确认账号" />
                                <Step disabled={this.state.stepTwoDisabled} title="重置密码" />
                                <Step disabled={this.state.stepThreeDisabled} title="重置成功" />
                            </Steps>
                            <div className="forgetPassword-form">
                            {
                                this.state.current === 0 &&
                                    <Form
                                        {...layout}
                                        name="basic"
                                        initialValues={{remember: true}}
                                    >
                                        <Form.Item
                                            label="账号（手机号码）"
                                            name="phone"
                                            rules={[{required: true, message: '请输入手机账号!'}]}
                                        >
                                            <Input
                                                placeholder="请输入绑定的手机号"
                                                defaultValue={this.state.phone}
                                                onChange={this.handleInputTelNumber.bind(this)}/>
                                        </Form.Item>
                                        <Button
                                            className="forgetPasswordButton"
                                            type="primary"
                                            onClick={this.switchStep.bind(this)}
                                        >
                                            确认
                                        </Button>
                                    </Form>
                            }
                            {
                            this.state.current === 1 &&
                                <Form
                                    {...layout}
                                    name="basic"
                                    initialValues={{remember: true}}
                                >
                                    <Form.Item
                                        name="password"
                                        label="新密码"
                                        rules={[{required: true, message: '请输入密码!',},]}
                                        hasFeedback
                                    >
                                        <Input.Password onChange={this.handleInputPassword.bind(this)}/>
                                    </Form.Item>
                                    <Form.Item
                                        name="confirm"
                                        label="确认密码"
                                        dependencies={['password']}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message: '请确认你的密码!',
                                            },
                                            ({getFieldValue}) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('两次输入的密码不一致!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password onChange={this.handleConfirmPassword.bind(this)}/>
                                    </Form.Item>
                                    <Form.Item
                                        label="账号（手机号码）"
                                        name="phone"
                                    >
                                        <div>
                                            {this.state.confirmPhone}
                                            <Button
                                                type="link"
                                                onClick={this.returnStep1.bind(this)}
                                            >修改</Button></div>
                                    </Form.Item>
                                    <Form.Item
                                        name="checkNumber"
                                        label="验证码"
                                        rules={[{required: true, message: '请输入验证码!',}]}
                                        hasFeedback
                                    >
                                        <Input  onChange={this.handleInputCheckCode.bind(this)}/>
                                        {
                                            this.state.getCodeStatus === true?
                                            <Button
                                                className="checkNumberButton"
                                                type="primary"
                                                onClick={this.getCode.bind(this)}
                                            >发送验证码</Button>:
                                            <Button
                                                className="checkNumberButton"
                                                disabled
                                                type="primary"
                                            >{this.state.count}s后重新发送</Button>
                                        }

                                    </Form.Item>

                                    <Button
                                        className="forgetPasswordButton"
                                        type="primary"
                                        onClick={this.submit.bind(this)}
                                        >确认修改</Button>
                                </Form>
                            }
                            {
                                this.state.current === 2 &&
                                <Result
                                    icon={<SmileOutlined />}
                                    title="重置密码成功"
                                    extra={<Button type="primary" onClick={this.returnLogin.bind(this)}>返回登录页</Button>}
                                />
                            }
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        )
    }
}

export  default  forgetPassword;